import { combineReducers } from 'redux';
import * as types from '../constants/types';

const toggle = (state = false, action) => {
  switch (action.type) {
    case types.QUESTION_PREVIEW_TOGGLE:
      return action.expanded;
    default:
      return state;
  }
};

const item = (
  state = {
    id: 0,
    index: 0,
    store: '',
  },
  action,
) => {
  switch (action.type) {
    case types.QUESTION_ITEM_ID:
      if (action.item) {
        return action.item;
      }
      return state;

    default:
      return state;
  }
};

export default combineReducers({
  toggle,
  item,
});
